module.exports = __webpack_public_path__ + "static/media/PC500.c35ae46f.png";